<template>
  <div class="layout-default">
    <TopHeader />
    <PageHeader />
    <main class="layout-content">
      <slot>
        <div class="text-center p-5 m-5">{{$t('common.noContent')}}</div>
      </slot>
    </main>

    <div class="layout-footer">
      <TopFooter />
      <Footer class="footer-top" />
    </div>
    <floating-menu-mobile />
  </div>
</template>

<script>
import Footer from "../../molecules/Footer/Footer.vue";
import TopFooter from "../TopFooter.vue";
import TopHeader from "../TopHeader.vue";
import PageHeader from "../PageHeader.vue";
import FloatingMenuMobile from "../../molecules/Mobile/FloatingMenuMobile.vue";

export default {
  name: "Home",
  components: {
    Footer,
    TopFooter,
    PageHeader,
    TopHeader,
    FloatingMenuMobile,
  },
};
</script>
<style scoped="scoped">
.layout-default {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.layout-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}

.layout-footer {
  margin-top: auto;
  display: flex;
  flex-direction: column;
}

.navbar .mobile_only_icon_group {
  display: none;
  float: right;
}

.navbar-header .logo img {
  max-width: 150px;
}

.footer-top {
  padding-top: 70px;
}
</style>
